import es_ES from './es-ES'
import en_US from './en-US'

export default {
  'en-US': en_US,
  'es-ES': es_ES,
  // 'pt-BR': pt_BR,
}
